import { TranslatePipe } from './../../../../shared/translate/pipes/translate.pipe';
import { AlertController } from '@ionic/angular';
import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class AlertService {
    alert: HTMLIonAlertElement;

    constructor(private alertController: AlertController, private translatePipe: TranslatePipe) { }

    async presentError(msg: string) {
        if (this.alert) {
            this.alert.dismiss();
        }
        this.alert = await this.alertController.create({
            message: this.translatePipe.transform(msg),
            buttons: [
                this.translatePipe.transform('OK')
            ]
        });
        await this.alert.present();
    }

    async presentDelete(text: string, subject: string, fu: any, byName: boolean = false) {
        if (this.alert) {
            this.alert.dismiss();
        }
        this.alert = await this.alertController.create({
            header: this.translatePipe.transform('DELETE_L'),
            message: this.translatePipe.transform('DEL') + '<br>' + '<b> ' + text + '</b> ' + this.translatePipe
                .transform(byName ? 'NAME_ALERT' : 'ID') + ' ' + this.translatePipe.transform(subject) + '?',
            buttons: [
                {
                    text: this.translatePipe.transform('CANCEL_L'),
                    role: 'cancel',
                    cssClass: 'secondary'
                }, {
                    text: this.translatePipe.transform('DELETE_L'),
                    handler: fu
                }
            ]
        });
        await this.alert.present();
    }

    async presentShortDelete(subject: string, fu: any, delMsg?: string) {
        if (this.alert) {
            this.alert.dismiss();
        }
        this.alert = await this.alertController.create({
            header: this.translatePipe.transform('DELETE_L'),
            message: subject && !delMsg ? this.translatePipe.transform('DEL2') + ' ' + this.translatePipe.transform(subject) + '?' :
                this.translatePipe.transform(delMsg),
            buttons: [
                {
                    text: this.translatePipe.transform('CANCEL_L'),
                    role: 'cancel',
                    cssClass: 'secondary'
                }, {
                    text: this.translatePipe.transform('DELETE_L'),
                    handler: fu
                }
            ]
        });
        await this.alert.present();
    }

    async presentBloodTypeAlert(hasBloodType: boolean, fu1: any, fu2: any) {
        if (this.alert) { this.alert.dismiss(); }
        this.alert = await this.alertController.create({
            header: this.translatePipe.transform(hasBloodType ? 'BLOOD_TYPE_CHANGE_T' : 'BLOOD_TYPE_CREATE_T'),
            message: this.translatePipe.transform(hasBloodType ? 'BLOOD_TYPE_CHANGE_M' : 'BLOOD_TYPE_CREATE_M'),
            buttons: [
                {
                    text: this.translatePipe.transform('CANCEL_L'),
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: fu2
                }, {
                    text: this.translatePipe.transform('YES'),
                    handler: fu1
                }
            ]
        });
        await this.alert.present();
    }

    async presentChangeEmail(email: string, fu: any) {
        if (this.alert) {
            this.alert.dismiss();
        }
        this.alert = await this.alertController.create({
            header: this.translatePipe.transform('NEW_EMAIL_REQ'),
            message: this.translatePipe.transform('EMAIL_SURE_ONE') + '<b>' + email
                + '</b>' + this.translatePipe.transform('EMAIL_SURE_TWO') + '?',
            buttons: [
                {
                    text: this.translatePipe.transform('CANCEL_L'),
                    role: 'cancel',
                    cssClass: 'secondary'
                },
                {
                    text: this.translatePipe.transform('YES'),
                    handler: fu
                }
            ]
        });
        this.alert.present();
    }

    async presentPatientInactivation(fu1: any, fu2?: any) {
        if (this.alert) {
            this.alert.dismiss();
        }
        this.alert = await this.alertController.create({
            header: '',
            message: this.translatePipe.transform('INACTIVATE_PATIENT_MESSAGE'),
            buttons: [
                {
                    text: this.translatePipe.transform('CANCEL_L'),
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: fu2
                }, {
                    text: this.translatePipe.transform('YES'),
                    handler: fu1
                }
            ]
        });
        await this.alert.present();
    }
}
